import { render } from "./QualityStandard.vue?vue&type=template&id=74e54eae"
import script from "./QualityStandard.vue?vue&type=script&lang=js"
export * from "./QualityStandard.vue?vue&type=script&lang=js"

import "./QualityStandard.vue?vue&type=style&index=0&id=74e54eae&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__